import controller from './query-rule-operator.controller';
import template from './query-rule-operator.html';

export default {
	controller,
	template,
	bindings: {
		rule:  '<ngModel',
		group: '<group',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		children:    '^^?queryBuilderChildren',
	},
	controllerAs: '$ctrl',
};
